module.exports = __webpack_public_path__ + "static/media/inner-6.9534d24f.jpg";